import React from "react";

// Visual boundary only: no client code, credential handling or connection path.
export default function RemoteViewerSlot() {
  return <section className="remote-viewer-placeholder" aria-label="Visor remoto pendiente de autorización">
    <div><span className="remote-viewer-icon">▣</span><strong>Escritorio remoto</strong><p>El acceso web se habilitará cuando estén verificadas la autorización temporal y la revocación efectiva de sesiones.</p></div>
    <small>Sin conexión iniciada</small>
  </section>;
}
